const SELECT_ADDON = 1;
const SELECT_STANDALONE_ADDON = 2;
const SET_STEP = 3;
const LOAD_DATA = 4;
const DATA_LOADING = 5;
const CLOSE_JOURNEY = 6;
const COMPLETE_JOURNEY = 7;
const SEASON_TICKETS_TOGGLE = 8;


//Journey steps
const STEP_1_START = 1;
const STEP_2_ORDER_REVIEW = 2;
const STEP_3_EXISTING_CUSTOMER = 3;
const STEP_4_ACCOUNT = 4;
const STEP_5_ACCOUNT_CREDENTIALS = 5;
const STEP_5b_PERSONAL_DETAILS = 5.5;
const STEP_6_ACCOUNT_DETAILS = 6;
const STEP_7_ORDER_CONFIRMATION = 7;
const STEP_8_PAYMENT_FRAME = 8;
const STEP_9_ORDER_COMPLETE = 9;


export default {
    SELECT_ADDON,
    SELECT_STANDALONE_ADDON,
    SET_STEP,
    LOAD_DATA,
    DATA_LOADING,
    CLOSE_JOURNEY,
    COMPLETE_JOURNEY,
    SEASON_TICKETS_TOGGLE,

    STEP_1_START,
    STEP_2_ORDER_REVIEW,
    STEP_3_EXISTING_CUSTOMER,
    STEP_4_ACCOUNT,
    STEP_5_ACCOUNT_CREDENTIALS,
    STEP_5b_PERSONAL_DETAILS,
    STEP_6_ACCOUNT_DETAILS,
    STEP_7_ORDER_CONFIRMATION,
    STEP_8_PAYMENT_FRAME,
    STEP_9_ORDER_COMPLETE
}